






















import Vue, { PropType } from 'vue'
import { SingleActions, Actions } from '@/shared/Actions'

export default Vue.extend({
  name: 'RoomForm',
  props: {
    edit: {
      type: [Boolean] as PropType<boolean>,
      default: false
    },
    entry: {
      type: [Object] as PropType<any>,
      default: () => ({
        name: null as string | null,
        size: 0 as number | null
      })
    }
  },
  computed: {
    isProcessing(): boolean {
      return this.edit
        ? this.$store.state.isProcessing[Actions.UPDATE_ROOM][this.entry._id]
        : this.$store.state.isProcessing[SingleActions.CREATE_ROOM]
    }
  },
  methods: {
    handleSubmit() {
      const { name, size } = this.entry
      this.$emit('onSubmit', { name, size })
      this.entry.name = null
      this.entry.size = 0
    }
  }
})
